import { useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { SearchEimPageUrl } from '~/pages/urls';

export const useSearchEimNavigate = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const navigateToSearchEim = useCallback(() => {
    const { market = '', requestId = '', ...others } = params;
    const state = {
      ...Object.fromEntries(searchParams),
      ...others,
    };
    const url = SearchEimPageUrl.expand({
      market,
      requestId,
    });
    navigate(url, { replace: true, state });
  }, [navigate, params, searchParams]);

  return navigateToSearchEim;
}
